// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-qWx_","type":"styles_type__3WW1M","choices":"styles_choices__1-TVN"};